module.exports = __webpack_public_path__ + "static/media/comment-alt-solid9877d593.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/therapist/images/comment-alt-solid.svg
// module id = 667
// module chunks = 0